module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-charge"
  }, [_c('h2', [_vm._v(_vm._s(_vm.contract_id ? '' : '空房') + "水电充值")]), _c('div', {
    staticClass: "ui two columns stackable grid form"
  }, [_c('div', {
    staticClass: "column"
  }, [(!_vm.$config.logic.manual_meter) ? [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui button orange",
    on: {
      "click": function($event) {
        _vm.set({
          electricity: 100
        })
      }
    }
  }, [_vm._v("电100度")]), _c('div', {
    staticClass: "ui button yellow",
    on: {
      "click": function($event) {
        _vm.set({
          electricity: 70
        })
      }
    }
  }, [_vm._v("电70度")]), _c('div', {
    staticClass: "ui button yellow",
    on: {
      "click": function($event) {
        _vm.set({
          electricity: 50
        })
      }
    }
  }, [_vm._v("电50度")]), _c('div', {
    staticClass: "ui button blue",
    on: {
      "click": function($event) {
        _vm.set({
          water: 16
        })
      }
    }
  }, [_vm._v("冷水16吨")]), _c('div', {
    staticClass: "ui button themed",
    on: {
      "click": function($event) {
        _vm.set({
          kitchen: 50
        })
      }
    }
  }, [_vm._v("厨房50度")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.set({
          water: 0,
          hot_water: 0,
          electricity: 0,
          kitchen: 0
        })
      }
    }
  }, [_vm._v("重置")])]), _c('br'), _c('div', {
    staticClass: "ui four fields"
  }, _vm._l((_vm.form.utilities), function(utility) {
    return _c('div', {
      staticClass: "ui field"
    }, [_c('label', [_vm._v(_vm._s(_vm.$formatters.utility_label(utility.type)) + " / " + _vm._s(_vm.$formatters.utility_unit(utility.type)))]), _c('compare-input', {
      attrs: {
        "min": 0,
        "allow-dot": false
      },
      model: {
        value: (utility.quantity),
        callback: function($$v) {
          _vm.$set(utility, "quantity", $$v)
        },
        expression: "utility.quantity"
      }
    })], 1)
  }))] : _vm._e(), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("支付方式")]), _c('payment-method-select', {
    model: {
      value: (_vm.form.payment_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "payment_method", $$v)
      },
      expression: "form.payment_method"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("备注")]), _c('el-input', {
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)]), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("厨房开户费用")]), _c('compare-input', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.kitchen_open_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "kitchen_open_fee", $$v)
      },
      expression: "form.kitchen_open_fee"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("补卡费用")]), _c('compare-input', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.card_replenish_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_replenish_fee", $$v)
      },
      expression: "form.card_replenish_fee"
    }
  })], 1)])], 2), _c('div', {
    staticClass: "column"
  }, [_c('receipts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receipts && _vm.receipts.length),
      expression: "receipts && receipts.length"
    }],
    staticClass: "ui segment",
    attrs: {
      "receipts": _vm.receipts
    }
  })], 1), _c('div', {
    staticClass: "ui field actions"
  }, [(_vm.$native.supported && !_vm.$config.logic.manual_meter) ? [_c('div', {
    staticClass: "ui button themed icon labeled",
    class: {
      disabled: !_vm.submitable && !_vm.auto_chargable
    },
    on: {
      "click": function($event) {
        _vm.finish(true)
      }
    }
  }, [_c('i', {
    staticClass: "icon rocket"
  }), _vm._v("自动充值")]), _c('div', {
    staticClass: "ui button olive icon labeled",
    class: {
      disabled: !_vm.submitable
    },
    on: {
      "click": function($event) {
        _vm.finish(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("手动充值")])] : [_c('div', {
    staticClass: "ui button themed icon labeled",
    class: {
      disabled: !_vm.submitable
    },
    on: {
      "click": function($event) {
        _vm.finish()
      }
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("完成充值")])], _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 2)]), _c('el-dialog', {
    attrs: {
      "title": "自动充值中",
      "visible": _vm.dialog_charging,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_charging = $event
      }
    }
  }, [_c('span', [_vm._v("请插入水电卡并等待充值过程完成。")]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.native_charge_cancel()
      }
    }
  }, [_vm._v("取消")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.native_charge_confirm()
      }
    }
  }, [_vm._v("完成")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1544f8c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormCharge.vue
// module id = 379
// module chunks = 0